import styled from 'styled-components';

export const Button = styled.button`
  background-color: #cf4647;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 10px;
  cursor: pointer;
`;
